import React from 'react'
import PropTypes from 'prop-types'

import AuthorizePlatformDetails from '../../../pages/SocialAuthorize/AuthorizePlatformDetails'

import usePlatformConnected from '../../../features/hooks/usePlatformConnected'

// similar to SocialAuthChecker, but for multiple platforms
const SocialAuthCheckerMulti = ({ children, platforms, hasPadding, contentAlign }) => {
  // get object with requested platforms and their connection status
  const isPlatformsConnected = usePlatformConnected(platforms)
  const notConnectedPlatforms = Object.keys(isPlatformsConnected).filter(platform => !isPlatformsConnected[platform])

  return !!notConnectedPlatforms.length
    ? notConnectedPlatforms.map(platform => {
        return (
          <AuthorizePlatformDetails selectedPlatform={platform} hasPadding={hasPadding} contentAlign={contentAlign} />
        )
      })
    : children
}

SocialAuthCheckerMulti.propTypes = {
  dataFetch: PropTypes.func,
  platforms: PropTypes.array.isRequired,
  // styling pops:
  hasPadding: PropTypes.bool,
  contentAlign: PropTypes.string
}

export default SocialAuthCheckerMulti
